import React from 'react';
import { motion } from 'framer-motion';
export function ProductVideo() {
  return <section className="py-20 px-4 bg-white overflow-hidden" data-id="element-144">
      <div className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-146">
          <h2 className="text-3xl md:text-5xl font-black text-[#5d4037] mb-4 uppercase tracking-tight" data-id="element-147">
            Mirá cómo es el material por dentro
          </h2>
          <p className="text-xl text-[#8b6b61] font-medium max-w-2xl mx-auto" data-id="element-148">
            Un adelanto exclusivo de lo que vas a encontrar directamente en tu
            celular, listo para aprender.
          </p>
        </motion.div>

        {/* iPhone Frame with Entrance Animation */}
        <motion.div initial={{
        y: 200,
        opacity: 0,
        rotateX: 20,
        scale: 0.9
      }} whileInView={{
        y: 0,
        opacity: 1,
        rotateX: 0,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        type: 'spring',
        duration: 1.5,
        bounce: 0.3,
        delay: 0.2
      }} style={{
        perspective: 1000
      }} className="relative w-[300px] h-[615px] md:w-[320px] md:h-[650px] bg-black rounded-[3rem] border-[10px] border-gray-900 shadow-[0_30px_60px_rgba(0,0,0,0.4)] ring-4 ring-gray-800/50 z-10" data-id="element-149">
          {/* Side Buttons (Volume/Power) */}
          <div className="absolute top-24 -left-[14px] w-1 h-12 bg-gray-800 rounded-l-md" data-id="element-150"></div>
          <div className="absolute top-40 -left-[14px] w-1 h-12 bg-gray-800 rounded-l-md" data-id="element-151"></div>
          <div className="absolute top-32 -right-[14px] w-1 h-16 bg-gray-800 rounded-r-md" data-id="element-152"></div>

          {/* Dynamic Island / Notch */}
          <div className="absolute top-3 left-1/2 -translate-x-1/2 w-24 h-7 bg-black rounded-full z-20 flex items-center justify-end px-2" data-id="element-153">
            <div className="w-2.5 h-2.5 bg-gray-800 rounded-full opacity-50" data-id="element-154"></div>
          </div>

          {/* Screen Content */}
          <div className="w-full h-full bg-[#1a1a1a] rounded-[2.2rem] overflow-hidden relative" data-id="element-155">
            <video src="https://cdn.magicpatterns.com/uploads/oyUroPtZV8pQCCcSQYCffT/CURSOSOS.mp4" className="w-full h-full object-cover" autoPlay muted loop playsInline data-id="element-156" />
          </div>
        </motion.div>
      </div>
    </section>;
}